import { usePostFlowContext } from "@/components/PostDialogs/SharedPostFlowContext";
import React from "react";
import { CaptionCoach } from "@/components/CaptionCoach";
import { useSocialCoachSession } from "@/utils";

export function CaptionCoachStep() {
  const { media, setPendingCaption, setBlockedWords, initialScript, setFlaggedWords, onBehalfOf, effectivePlayerId } =
    usePostFlowContext();
  const { coachId } = useSocialCoachSession();

  const firstTranscript = media.filter(m => m.category === "VIDEO").map(m => m.transcripts?.[0])[0]?.content;

  const context = firstTranscript || initialScript;
  const contextType = firstTranscript ? "video transcript" : "video script";

  return (
    <CaptionCoach
      handlePrediction={setPendingCaption}
      handleBlockedWords={setBlockedWords}
      handleFlaggedWords={setFlaggedWords}
      context={context}
      contextType={contextType}
      playerIdOverride={onBehalfOf ? effectivePlayerId : undefined}
      coachIdOverride={onBehalfOf ? coachId ?? undefined : undefined}
    />
  );
}
